import APIManager from 'modules/common/apiManager';
import { isAccess } from 'modules/common/utils';
import {
	Alert,
	Button,
	CommonPermission,
	ControlLabel,
	FormColumn,
	FormControl,
	FormGroup,
	FormWrapper,
	ModalFooter,
} from 'modules/theme';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select-plus';
import { globalAction } from '../../../../../store/action';
import { globalStateSelector } from '../../../../../store/selector';
import {
	ModalForm,
	ModalFormContainer,
} from '../../../../theme/theme1/common/styles/main';

export class PermissionsAddEditNew extends Component {
	constructor(props) {
		super(props);
		this.mAPI = new APIManager();
		this.state = {
			loading: true,
			name: null,
			baseRole: null,
		};

		if (props.editData && props.editData.roleName && props.editData.baseRole) {
			this.state = {
				name: props.editData.roleName.trim(),
				baseRole: props.editData.baseRole,
			};
		}
	}
	componentDidMount() {
		if (this.props.editData) {
			this.setState({ disabled: !isAccess(this.props.access, 'edit') });
		}
		this.getConfig();
	}

	generateBaseRole(tData) {
		return (
			tData &&
			tData.map((tD) => ({
				value: tD.value,
				label: tD.role,
			}))
		);
	}

	getConfig() {
		const { dynamicUpdate, editData } = this.props;
		this.setState({ loading: true });
		this.mAPI.sendGetAPI(
			`access-role/config`,
			(data) => {
				if (data && data.accessList && data.accessConfig) {
					this.setState({
						loading: false,
						accessList: data.accessList,
						accessConfig: data.accessConfig,
					});
					dynamicUpdate({ key: 'permissionType', value: 'admin' });
					if (editData && editData.accessDefination) {
						dynamicUpdate({
							key: 'permissionAccessDefination',
							value: editData.accessDefination,
						});
					}
				}
			},
			(error, data) => {
				console.log(`Error:`, error);
				this.setState({ loading: false });
				if (data) {
					Alert.error(`${data.message}`);
				} else {
					Alert.error(`${error}`);
				}
			}
		);
	}

	renderFormGroup(label, props) {
		return (
			<FormGroup>
				<ControlLabel required={props.required}>{label}</ControlLabel>
				<FormControl {...props} />
			</FormGroup>
		);
	}
	apiResponse(errorCode, data) {
		if (errorCode === 201) {
			// Alert.success(`${data.message}`);
			let message = data && data.message ? data.message : 'Successfully Done';
			Alert.success(message);
			this.resetAllData();
			this.props.closeModal(true);
		} else {
			let message =
				data && data.message ? data.message : 'Something wrong happened';
			Alert.error(message);
		}
	}

	saveData(e) {
		let _this = this;
		const { permissionAccessDefination } = this.props;
		this.setState({ loading: true });
		e.preventDefault();

		if (!this.state.name) {
			this.setState({ loading: false });
			return Alert.error('Please enter name.');
		} else if (!this.state.baseRole) {
			this.setState({ loading: false });
			return Alert.error('Please select base role.');
		}
		let name = this.state.name.trim();

		let tData = {
			name,
			baseRole: this.state.baseRole,
			accessDefination: permissionAccessDefination,
		};

		if (this.props.editData) {
			this.mAPI.sendPostAPI(
				`access-role/${this.props.editData._id}`,
				tData,
				(data) => {
					console.log(JSON.stringify(data, null, 2));
					if (data) {
						this.setState({ loading: false });
						_this.resetAllData();
						_this.props.closeModal(true);
						Alert.success(`Permission ${tData.name} updated successfully.`);
					}
				},
				(errorCode, data) => {
					this.setState({ loading: false });
					this.apiResponse(errorCode, data);
				},
				'private',
				{ id: tData._id },
				'PUT'
			);
		} else {
			this.mAPI.sendPostAPI(
				'access-role',
				tData,
				(data) => {
					this.setState({ loading: false });
					if (data && data.message) {
						// Alert.success(`${data.message}`);
						Alert.success(`Permission created successfully`);
					} else {
						Alert.success(`Successfully Added`);
					}
					this.resetAllData();
					this.props.update();
					this.props.closeModal(true);
				},
				(errorCode, data) => {
					this.setState({ loading: false });
					this.apiResponse(errorCode, data);
				}
			);
		}
	}

	resetAllData() {
		this.setState({
			name: '',
		});
	}

	render() {
		const { modalType, dynamicUpdate } = this.props;
		return (
			<ModalForm onSubmit={(e) => this.saveData(e)}>
				<ModalFormContainer>
					<FormWrapper>
						<FormColumn>
							{this.renderFormGroup('Name', {
								defaultValue: '',
								placeholder: 'Name',
								maxLength: 25,
								autoFocus: true,
								disabled: this.state.disabled,
								required: true,
								id: 'name',
								value: this.state.name,
								onChange: (e) => {
									if (!e.target.value.trim() && e.target.value !== '') {
										return false;
									}
									this.setState({ name: e.target.value });
								},
							})}
						</FormColumn>
					</FormWrapper>
					<FormGroup>
						<ControlLabel required>Base Role</ControlLabel>
						<Select
							defaultValue=''
							placeholder='Base Role'
							disabled={this.state.disabled}
							onChange={(item) => {
								if (item && item.value) {
									this.setState({
										baseRole: item.value,
									});
									// dynamicUpdate({
									//   key: 'permissionAccessDefination',
									//   value:
									//     item.value === 2
									//       ? permissionAdminObject
									//       : item.value === 5
									//       ? permissionTLObject
									//       : permissionAgentObject,
									// });
									dynamicUpdate({
										key: 'permissionAccessDefination',
										value: this.state.accessList[
											this.state.accessConfig[item.value]
										],
									});
								} else {
									this.setState({
										baseRole: null,
									});
								}
							}}
							value={this.state.baseRole}
							options={this.generateBaseRole(this.props.defaultRole)}
						/>
					</FormGroup>
					{this.state.baseRole &&
						this.props.permissionAccessDefination &&
						this.props.permissionType === 'admin' && (
							<CommonPermission
								disabled={this.state.disabled}
								permissions={this.props.permissionAccessDefination}
							/>
						)}
				</ModalFormContainer>

				<ModalFooter modalType={modalType}>
					<Button
						className='grey-btn'
						btnStyle='cancel'
						onClick={() => this.props.closeModal()}
						size='xl'
					>
						Cancel
					</Button>
					{!this.state.disabled && (
						<Button
							className='blue-btn'
							type='submit'
							btnStyle='default'
							size='xl'
							style={{ float: 'right' }}
							disabled={this.state.loading}
						>
							{this.props.editData && this.props.editData._id
								? 'Update'
								: 'Add'}
						</Button>
					)}
				</ModalFooter>
			</ModalForm>
		);
	}
}

const stateToProps = (state) => ({
	permissionAccessDefination: globalStateSelector.getDynamic(state, {
		key: 'permissionAccessDefination',
	}),
	permissionType: globalStateSelector.getDynamic(state, {
		key: 'permissionType',
	}),
	access: globalStateSelector.getPermission(state, 'permission'),
});

const dispatchToProps = (dispatch) => ({
	dynamicUpdate: (data) => {
		dispatch(globalAction.dynamicUpdate({ data }));
	},
});

export default connect(stateToProps, dispatchToProps)(PermissionsAddEditNew);



// WEBPACK FOOTER //
// src/modules/screens/settings/Permissions/components/AddEdit.jsx